import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface PackageObject {
  id: number;
  titleEn: string;
  titleAr: string;
  descriptionEn: string;
  descriptionAr: string;
  slug: string;
  isActive: boolean;
  sort: number;
  price: number;
  discountPercentage: number;
  offeredPrice: number;
  type: number;
  iveCredits: number;
  adsCredits: number;
  daysCovered: number;
  color: string;
  realtedTypeSlug: number;
}

export interface PackageListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  packages: Array<PackageObject>;
  errors: unknown;
}
@Module
export default class PackagesModule
  extends VuexModule
  implements PackageListInfo
{
  packages = [] as Array<PackageObject>;
  allPackages = [] as Array<PackageObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get Ads list
   * @returns Array<AdsObject>
   */
  get packagesList(): Array<PackageObject> {
    return this.packages;
  }

  get allPackagesList(): Array<PackageObject> {
    return this.allPackages;
  }

  /**
   * Get total items
   * @returns number
   */
  get packagesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_PACKAGES](data) {
    this.packages = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_PACKAGES](data) {
    this.allPackages = data.data;
  }

  @Mutation
  [Mutations.SET_PACKAGES_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_PACKAGE_LIST]() {
    this.packages = [] as Array<PackageObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_PACKAGE_STORE]() {
    this.context.commit(Mutations.RESET_PACKAGE_LIST);
  }

  @Action
  [Actions.UPDATE_PACKAGES_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_PACKAGES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_PACKAGE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/packages', id);
  }

  @Action
  [Actions.GET_PACKAGES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/packages', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        data.data = data.data.map((r) => {
          r.createdAt = new Date(r.createdAt)
            .toLocaleString('en-GB')
            .split(',')[0];
          return r;
        });
        this.context.commit(Mutations.SET_PACKAGES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_PACKAGES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/packages/all', {})
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_PACKAGES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.CREATE_PACKAGE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/packages', data)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_PACKAGE_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
  @Action
  [Actions.UPDATE_PACKAGE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/packages', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_PACKAGE_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_PACKAGE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/packages', id)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_PACKAGE_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
